var _g, _defs, _mask, _ellipse, _path, _mask2, _ellipse2, _path2, _mask3, _ellipse3, _path3, _mask4, _ellipse4, _path4, _mask5, _ellipse5, _path5, _mask6, _ellipse6, _path6, _mask7, _ellipse7, _path7, _mask8, _ellipse8, _path8, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconConversation = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 80,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13398_258136)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 5.38171,
    rx: 1.6019,
    ry: 1.6073
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 5.38171,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.141 5.38171H135.503C135.503 5.38212 135.503 5.38081 135.504 5.37832C135.504 5.37593 135.505 5.37343 135.506 5.37108C135.508 5.3666 135.51 5.36379 135.512 5.36196C135.514 5.36012 135.517 5.35737 135.523 5.35487C135.53 5.35191 135.537 5.35102 135.539 5.35102V6.98901V8.62701C137.334 8.62701 138.779 7.16884 138.779 5.38171H137.141ZM135.539 6.98901V5.35102C135.542 5.35102 135.549 5.35191 135.556 5.35487C135.562 5.35737 135.565 5.36012 135.567 5.36196C135.569 5.36379 135.571 5.3666 135.573 5.37108C135.574 5.37343 135.575 5.37593 135.575 5.37832C135.576 5.38081 135.575 5.38212 135.575 5.38171H133.938H132.3C132.3 7.16884 133.745 8.62701 135.539 8.62701V6.98901ZM133.938 5.38171H135.575C135.575 5.3813 135.576 5.38262 135.575 5.38511C135.575 5.3875 135.574 5.39 135.573 5.39235C135.571 5.39683 135.569 5.39964 135.567 5.40147C135.565 5.4033 135.562 5.40606 135.556 5.40855C135.549 5.41152 135.542 5.41241 135.539 5.41241V3.77441V2.13642C133.745 2.13642 132.3 3.59458 132.3 5.38171H133.938ZM135.539 3.77441V5.41241C135.537 5.41241 135.53 5.41152 135.523 5.40855C135.517 5.40606 135.514 5.4033 135.512 5.40147C135.51 5.39964 135.508 5.39683 135.506 5.39235C135.505 5.39 135.504 5.3875 135.504 5.38511C135.503 5.38262 135.503 5.3813 135.503 5.38171H137.141H138.779C138.779 3.59458 137.334 2.13642 135.539 2.13642V3.77441Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_13398_258136)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 27.6704,
    rx: 0.947465,
    ry: 0.950657
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 27.6704,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 27.6704H158.362C158.362 27.296 158.666 26.983 159.053 26.983V28.621V30.259C160.486 30.259 161.638 29.0949 161.638 27.6704H160ZM159.053 28.621V26.983C159.439 26.983 159.743 27.296 159.743 27.6704H158.105H156.467C156.467 29.0949 157.62 30.259 159.053 30.259V28.621ZM158.105 27.6704H159.743C159.743 28.0448 159.439 28.3577 159.053 28.3577V26.7197V25.0817C157.62 25.0817 156.467 26.2459 156.467 27.6704H158.105ZM159.053 26.7197V28.3577C158.666 28.3577 158.362 28.0448 158.362 27.6704H160H161.638C161.638 26.2459 160.486 25.0817 159.053 25.0817V26.7197Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_13398_258136)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 16.1196,
    rx: 0.947465,
    ry: 0.950657
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 16.1196,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89493 16.1196H0.256935C0.256935 15.7452 0.560907 15.4323 0.947465 15.4323V17.0703V18.7083C2.38056 18.7083 3.53293 17.5441 3.53293 16.1196H1.89493ZM0.947465 17.0703V15.4323C1.33402 15.4323 1.638 15.7452 1.638 16.1196H0H-1.638C-1.638 17.5441 -0.485634 18.7083 0.947465 18.7083V17.0703ZM0 16.1196H1.638C1.638 16.494 1.33402 16.8069 0.947465 16.8069V15.1689V13.531C-0.485634 13.531 -1.638 14.6951 -1.638 16.1196H0ZM0.947465 15.1689V16.8069C0.560907 16.8069 0.256935 16.494 0.256935 16.1196H1.89493H3.53293C3.53293 14.6951 2.38056 13.531 0.947465 13.531V15.1689Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_13398_258136)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 52.5434,
    rx: 0.947465,
    ry: 0.950657
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 52.5434,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.85 52.5434H21.212C21.212 52.169 21.516 51.8561 21.9025 51.8561V53.4941V55.1321C23.3356 55.1321 24.488 53.9679 24.488 52.5434H22.85ZM21.9025 53.4941V51.8561C22.2891 51.8561 22.5931 52.169 22.5931 52.5434H20.9551H19.3171C19.3171 53.9679 20.4694 55.1321 21.9025 55.1321V53.4941ZM20.9551 52.5434H22.5931C22.5931 52.9178 22.2891 53.2308 21.9025 53.2308V51.5928V49.9548C20.4694 49.9548 19.3171 51.119 19.3171 52.5434H20.9551ZM21.9025 51.5928V53.2308C21.516 53.2308 21.212 52.9178 21.212 52.5434H22.85H24.488C24.488 51.119 23.3356 49.9548 21.9025 49.9548V51.5928Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_13398_258136)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 31.8906,
    rx: 0.947465,
    ry: 0.950657
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 31.8906,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.135 31.8906H130.497C130.497 31.5162 130.801 31.2033 131.188 31.2033V32.8413V34.4792C132.621 34.4792 133.773 33.3151 133.773 31.8906H132.135ZM131.188 32.8413V31.2033C131.574 31.2033 131.878 31.5162 131.878 31.8906H130.24H128.602C128.602 33.3151 129.755 34.4792 131.188 34.4792V32.8413ZM130.24 31.8906H131.878C131.878 32.265 131.574 32.5779 131.188 32.5779V30.9399V29.3019C129.755 29.3019 128.602 30.4661 128.602 31.8906H130.24ZM131.188 30.9399V32.5779C130.801 32.5779 130.497 32.265 130.497 31.8906H132.135H133.773C133.773 30.4661 132.621 29.3019 131.188 29.3019V30.9399Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_13398_258136)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.022,
    cy: 75.5493,
    rx: 0.947465,
    ry: 0.950657
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.022,
    cy: 75.5493,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.969 75.5493H114.331C114.331 75.1749 114.635 74.862 115.022 74.862V76.4999V78.1379C116.455 78.1379 117.607 76.9738 117.607 75.5493H115.969ZM115.022 76.4999V74.862C115.408 74.862 115.712 75.1749 115.712 75.5493H114.074H112.436C112.436 76.9738 113.589 78.1379 115.022 78.1379V76.4999ZM114.074 75.5493H115.712C115.712 75.9237 115.408 76.2366 115.022 76.2366V74.5986V72.9606C113.589 72.9606 112.436 74.1248 112.436 75.5493H114.074ZM115.022 74.5986V76.2366C114.635 76.2366 114.331 75.9237 114.331 75.5493H115.969H117.607C117.607 74.1248 116.455 72.9606 115.022 72.9606V74.5986Z",
    fill: "currentColor",
    mask: "url(#path-11-inside-6_13398_258136)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 4.45066,
    rx: 0.947465,
    ry: 0.950657
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 4.45066,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.143 4.45066H33.505C33.505 4.07625 33.809 3.76332 34.1955 3.76332V5.40131V7.03931C35.6286 7.03931 36.781 5.87513 36.781 4.45066H35.143ZM34.1955 5.40131V3.76332C34.5821 3.76332 34.886 4.07625 34.886 4.45066H33.248H31.6101C31.6101 5.87513 32.7624 7.03931 34.1955 7.03931V5.40131ZM33.248 4.45066H34.886C34.886 4.82507 34.5821 5.138 34.1955 5.138V3.5V1.862C32.7624 1.862 31.6101 3.02618 31.6101 4.45066H33.248ZM34.1955 3.5V5.138C33.809 5.138 33.505 4.82507 33.505 4.45066H35.143H36.781C36.781 3.02618 35.6286 1.862 34.1955 1.862V3.5Z",
    fill: "currentColor",
    mask: "url(#path-13-inside-7_13398_258136)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 63.2455,
    rx: 1.6019,
    ry: 1.6073
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 63.2455,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86299 63.2455H2.22499C2.22499 63.2459 2.22497 63.2446 2.22548 63.2421C2.22597 63.2397 2.22674 63.2372 2.22773 63.2348C2.22962 63.2304 2.23179 63.2276 2.23362 63.2257C2.23544 63.2239 2.23883 63.2211 2.24471 63.2186C2.2517 63.2157 2.25833 63.2148 2.26108 63.2148V64.8528V66.4908C4.05562 66.4908 5.50098 65.0326 5.50098 63.2455H3.86299ZM2.26108 64.8528V63.2148C2.26384 63.2148 2.27047 63.2157 2.27746 63.2186C2.28333 63.2211 2.28672 63.2239 2.28855 63.2257C2.29038 63.2276 2.29255 63.2304 2.29443 63.2348C2.29542 63.2372 2.29619 63.2397 2.29668 63.2421C2.29719 63.2446 2.29717 63.2459 2.29717 63.2455H0.65918H-0.978815C-0.978815 65.0326 0.466547 66.4908 2.26108 66.4908V64.8528ZM0.65918 63.2455H2.29717C2.29717 63.2451 2.29719 63.2464 2.29668 63.2489C2.29619 63.2513 2.29542 63.2538 2.29443 63.2561C2.29255 63.2606 2.29038 63.2634 2.28855 63.2652C2.28672 63.2671 2.28333 63.2698 2.27746 63.2723C2.27047 63.2753 2.26384 63.2762 2.26108 63.2762V61.6382V60.0002C0.466547 60.0002 -0.978815 61.4584 -0.978815 63.2455H0.65918ZM2.26108 61.6382V63.2762C2.25833 63.2762 2.2517 63.2753 2.24471 63.2723C2.23883 63.2698 2.23544 63.2671 2.23362 63.2652C2.23179 63.2634 2.22962 63.2606 2.22773 63.2561C2.22674 63.2538 2.22597 63.2513 2.22548 63.2489C2.22497 63.2464 2.22499 63.2451 2.22499 63.2455H3.86299H5.50098C5.50098 61.4584 4.05562 60.0002 2.26108 60.0002V61.6382Z",
    fill: "currentColor",
    mask: "url(#path-15-inside-8_13398_258136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.085 23.8813C24.7533 23.8813 26.1102 25.2387 26.1104 26.9194C26.1104 28.6003 24.7534 29.9585 23.085 29.9585C21.4165 29.9585 20.0596 28.6003 20.0596 26.9194C20.0597 25.2387 21.4166 23.8814 23.085 23.8813Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.426 56.6709C132.414 56.6711 133.22 57.4755 133.22 58.4736C133.22 59.4716 132.414 60.2762 131.426 60.2764C130.438 60.2764 129.632 59.4717 129.632 58.4736C129.632 57.4754 130.438 56.6709 131.426 56.6709Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5156 26.3486H62.9399H69.3641",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5156 32.7729H59.7277H62.9399",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9395 45.6212C71.8095 45.6212 79.0001 38.4306 79.0001 29.5606C79.0001 20.6906 71.8095 13.5 62.9395 13.5C54.0695 13.5 46.8789 20.6906 46.8789 29.5606C46.8789 32.4859 47.661 35.2286 49.0275 37.5909L47.6819 44.8182L54.9092 43.4726C57.2715 44.8391 60.0142 45.6212 62.9395 45.6212Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9089 51.3639C87.4655 51.3639 87.1059 51.0043 87.1059 50.5608C87.1059 50.1174 87.4655 49.7578 87.9089 49.7578C88.3523 49.7578 88.7119 50.1174 88.7119 50.5608C88.7119 51.0043 88.3523 51.3639 87.9089 51.3639Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9392 51.3639C95.4957 51.3639 95.1361 51.0043 95.1361 50.5608C95.1361 50.1174 95.4957 49.7578 95.9392 49.7578C96.3826 49.7578 96.7422 50.1174 96.7422 50.5608C96.7422 51.0043 96.3826 51.3639 95.9392 51.3639Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.969 51.3639C103.526 51.3639 103.166 51.0043 103.166 50.5608C103.166 50.1174 103.526 49.7578 103.969 49.7578C104.413 49.7578 104.772 50.1174 104.772 50.5608C104.772 51.0043 104.413 51.3639 103.969 51.3639Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9394 66.6212C87.0694 66.6212 79.8788 59.4306 79.8788 50.5606C79.8788 41.6906 87.0694 34.5 95.9394 34.5C104.809 34.5 112 41.6906 112 50.5606C112 53.4859 111.218 56.2286 109.851 58.5909L111.197 65.8182L103.97 64.4726C101.607 65.8391 98.8647 66.6212 95.9394 66.6212Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13398_258136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white"
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 80,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13398_258136)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 5.38171,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 5.38171,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.141 5.38171H135.503C135.503 5.38212 135.503 5.38081 135.504 5.37832C135.504 5.37593 135.505 5.37343 135.506 5.37108C135.508 5.3666 135.51 5.36379 135.512 5.36196C135.514 5.36012 135.517 5.35737 135.523 5.35487C135.53 5.35191 135.537 5.35102 135.539 5.35102V6.98901V8.62701C137.334 8.62701 138.779 7.16884 138.779 5.38171H137.141ZM135.539 6.98901V5.35102C135.542 5.35102 135.549 5.35191 135.556 5.35487C135.562 5.35737 135.565 5.36012 135.567 5.36196C135.569 5.36379 135.571 5.3666 135.573 5.37108C135.574 5.37343 135.575 5.37593 135.575 5.37832C135.576 5.38081 135.575 5.38212 135.575 5.38171H133.938H132.3C132.3 7.16884 133.745 8.62701 135.539 8.62701V6.98901ZM133.938 5.38171H135.575C135.575 5.3813 135.576 5.38262 135.575 5.38511C135.575 5.3875 135.574 5.39 135.573 5.39235C135.571 5.39683 135.569 5.39964 135.567 5.40147C135.565 5.4033 135.562 5.40606 135.556 5.40855C135.549 5.41152 135.542 5.41241 135.539 5.41241V3.77441V2.13642C133.745 2.13642 132.3 3.59458 132.3 5.38171H133.938ZM135.539 3.77441V5.41241C135.537 5.41241 135.53 5.41152 135.523 5.40855C135.517 5.40606 135.514 5.4033 135.512 5.40147C135.51 5.39964 135.508 5.39683 135.506 5.39235C135.505 5.39 135.504 5.3875 135.504 5.38511C135.503 5.38262 135.503 5.3813 135.503 5.38171H137.141H138.779C138.779 3.59458 137.334 2.13642 135.539 2.13642V3.77441Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_13398_258136)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 27.6704,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 27.6704,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 27.6704H158.362C158.362 27.296 158.666 26.983 159.053 26.983V28.621V30.259C160.486 30.259 161.638 29.0949 161.638 27.6704H160ZM159.053 28.621V26.983C159.439 26.983 159.743 27.296 159.743 27.6704H158.105H156.467C156.467 29.0949 157.62 30.259 159.053 30.259V28.621ZM158.105 27.6704H159.743C159.743 28.0448 159.439 28.3577 159.053 28.3577V26.7197V25.0817C157.62 25.0817 156.467 26.2459 156.467 27.6704H158.105ZM159.053 26.7197V28.3577C158.666 28.3577 158.362 28.0448 158.362 27.6704H160H161.638C161.638 26.2459 160.486 25.0817 159.053 25.0817V26.7197Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_13398_258136)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 16.1196,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 16.1196,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89493 16.1196H0.256935C0.256935 15.7452 0.560907 15.4323 0.947465 15.4323V17.0703V18.7083C2.38056 18.7083 3.53293 17.5441 3.53293 16.1196H1.89493ZM0.947465 17.0703V15.4323C1.33402 15.4323 1.638 15.7452 1.638 16.1196H0H-1.638C-1.638 17.5441 -0.485634 18.7083 0.947465 18.7083V17.0703ZM0 16.1196H1.638C1.638 16.494 1.33402 16.8069 0.947465 16.8069V15.1689V13.531C-0.485634 13.531 -1.638 14.6951 -1.638 16.1196H0ZM0.947465 15.1689V16.8069C0.560907 16.8069 0.256935 16.494 0.256935 16.1196H1.89493H3.53293C3.53293 14.6951 2.38056 13.531 0.947465 13.531V15.1689Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_13398_258136)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 52.5434,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 52.5434,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.85 52.5434H21.212C21.212 52.169 21.516 51.8561 21.9025 51.8561V53.4941V55.1321C23.3356 55.1321 24.488 53.9679 24.488 52.5434H22.85ZM21.9025 53.4941V51.8561C22.2891 51.8561 22.5931 52.169 22.5931 52.5434H20.9551H19.3171C19.3171 53.9679 20.4694 55.1321 21.9025 55.1321V53.4941ZM20.9551 52.5434H22.5931C22.5931 52.9178 22.2891 53.2308 21.9025 53.2308V51.5928V49.9548C20.4694 49.9548 19.3171 51.119 19.3171 52.5434H20.9551ZM21.9025 51.5928V53.2308C21.516 53.2308 21.212 52.9178 21.212 52.5434H22.85H24.488C24.488 51.119 23.3356 49.9548 21.9025 49.9548V51.5928Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_13398_258136)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 31.8906,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 31.8906,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.135 31.8906H130.497C130.497 31.5162 130.801 31.2033 131.188 31.2033V32.8413V34.4792C132.621 34.4792 133.773 33.3151 133.773 31.8906H132.135ZM131.188 32.8413V31.2033C131.574 31.2033 131.878 31.5162 131.878 31.8906H130.24H128.602C128.602 33.3151 129.755 34.4792 131.188 34.4792V32.8413ZM130.24 31.8906H131.878C131.878 32.265 131.574 32.5779 131.188 32.5779V30.9399V29.3019C129.755 29.3019 128.602 30.4661 128.602 31.8906H130.24ZM131.188 30.9399V32.5779C130.801 32.5779 130.497 32.265 130.497 31.8906H132.135H133.773C133.773 30.4661 132.621 29.3019 131.188 29.3019V30.9399Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_13398_258136)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.022,
    cy: 75.5493,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.022,
    cy: 75.5493,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.969 75.5493H114.331C114.331 75.1749 114.635 74.862 115.022 74.862V76.4999V78.1379C116.455 78.1379 117.607 76.9738 117.607 75.5493H115.969ZM115.022 76.4999V74.862C115.408 74.862 115.712 75.1749 115.712 75.5493H114.074H112.436C112.436 76.9738 113.589 78.1379 115.022 78.1379V76.4999ZM114.074 75.5493H115.712C115.712 75.9237 115.408 76.2366 115.022 76.2366V74.5986V72.9606C113.589 72.9606 112.436 74.1248 112.436 75.5493H114.074ZM115.022 74.5986V76.2366C114.635 76.2366 114.331 75.9237 114.331 75.5493H115.969H117.607C117.607 74.1248 116.455 72.9606 115.022 72.9606V74.5986Z",
    fill: "currentColor",
    mask: "url(#path-11-inside-6_13398_258136)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 4.45066,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 4.45066,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.143 4.45066H33.505C33.505 4.07625 33.809 3.76332 34.1955 3.76332V5.40131V7.03931C35.6286 7.03931 36.781 5.87513 36.781 4.45066H35.143ZM34.1955 5.40131V3.76332C34.5821 3.76332 34.886 4.07625 34.886 4.45066H33.248H31.6101C31.6101 5.87513 32.7624 7.03931 34.1955 7.03931V5.40131ZM33.248 4.45066H34.886C34.886 4.82507 34.5821 5.138 34.1955 5.138V3.5V1.862C32.7624 1.862 31.6101 3.02618 31.6101 4.45066H33.248ZM34.1955 3.5V5.138C33.809 5.138 33.505 4.82507 33.505 4.45066H35.143H36.781C36.781 3.02618 35.6286 1.862 34.1955 1.862V3.5Z",
    fill: "currentColor",
    mask: "url(#path-13-inside-7_13398_258136)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_13398_258136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 63.2455,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 63.2455,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86299 63.2455H2.22499C2.22499 63.2459 2.22497 63.2446 2.22548 63.2421C2.22597 63.2397 2.22674 63.2372 2.22773 63.2348C2.22962 63.2304 2.23179 63.2276 2.23362 63.2257C2.23544 63.2239 2.23883 63.2211 2.24471 63.2186C2.2517 63.2157 2.25833 63.2148 2.26108 63.2148V64.8528V66.4908C4.05562 66.4908 5.50098 65.0326 5.50098 63.2455H3.86299ZM2.26108 64.8528V63.2148C2.26384 63.2148 2.27047 63.2157 2.27746 63.2186C2.28333 63.2211 2.28672 63.2239 2.28855 63.2257C2.29038 63.2276 2.29255 63.2304 2.29443 63.2348C2.29542 63.2372 2.29619 63.2397 2.29668 63.2421C2.29719 63.2446 2.29717 63.2459 2.29717 63.2455H0.65918H-0.978815C-0.978815 65.0326 0.466547 66.4908 2.26108 66.4908V64.8528ZM0.65918 63.2455H2.29717C2.29717 63.2451 2.29719 63.2464 2.29668 63.2489C2.29619 63.2513 2.29542 63.2538 2.29443 63.2561C2.29255 63.2606 2.29038 63.2634 2.28855 63.2652C2.28672 63.2671 2.28333 63.2698 2.27746 63.2723C2.27047 63.2753 2.26384 63.2762 2.26108 63.2762V61.6382V60.0002C0.466547 60.0002 -0.978815 61.4584 -0.978815 63.2455H0.65918ZM2.26108 61.6382V63.2762C2.25833 63.2762 2.2517 63.2753 2.24471 63.2723C2.23883 63.2698 2.23544 63.2671 2.23362 63.2652C2.23179 63.2634 2.22962 63.2606 2.22773 63.2561C2.22674 63.2538 2.22597 63.2513 2.22548 63.2489C2.22497 63.2464 2.22499 63.2451 2.22499 63.2455H3.86299H5.50098C5.50098 61.4584 4.05562 60.0002 2.26108 60.0002V61.6382Z",
    fill: "currentColor",
    mask: "url(#path-15-inside-8_13398_258136)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.085 23.8813C24.7533 23.8813 26.1102 25.2387 26.1104 26.9194C26.1104 28.6003 24.7534 29.9585 23.085 29.9585C21.4165 29.9585 20.0596 28.6003 20.0596 26.9194C20.0597 25.2387 21.4166 23.8814 23.085 23.8813Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.426 56.6709C132.414 56.6711 133.22 57.4755 133.22 58.4736C133.22 59.4716 132.414 60.2762 131.426 60.2764C130.438 60.2764 129.632 59.4717 129.632 58.4736C129.632 57.4754 130.438 56.6709 131.426 56.6709Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5156 26.3486H62.9399H69.3641",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5156 32.7729H59.7277H62.9399",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9395 45.6212C71.8095 45.6212 79.0001 38.4306 79.0001 29.5606C79.0001 20.6906 71.8095 13.5 62.9395 13.5C54.0695 13.5 46.8789 20.6906 46.8789 29.5606C46.8789 32.4859 47.661 35.2286 49.0275 37.5909L47.6819 44.8182L54.9092 43.4726C57.2715 44.8391 60.0142 45.6212 62.9395 45.6212Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9089 51.3639C87.4655 51.3639 87.1059 51.0043 87.1059 50.5608C87.1059 50.1174 87.4655 49.7578 87.9089 49.7578C88.3523 49.7578 88.7119 50.1174 88.7119 50.5608C88.7119 51.0043 88.3523 51.3639 87.9089 51.3639Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9392 51.3639C95.4957 51.3639 95.1361 51.0043 95.1361 50.5608C95.1361 50.1174 95.4957 49.7578 95.9392 49.7578C96.3826 49.7578 96.7422 50.1174 96.7422 50.5608C96.7422 51.0043 96.3826 51.3639 95.9392 51.3639Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.969 51.3639C103.526 51.3639 103.166 51.0043 103.166 50.5608C103.166 50.1174 103.526 49.7578 103.969 49.7578C104.413 49.7578 104.772 50.1174 104.772 50.5608C104.772 51.0043 104.413 51.3639 103.969 51.3639Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9394 66.6212C87.0694 66.6212 79.8788 59.4306 79.8788 50.5606C79.8788 41.6906 87.0694 34.5 95.9394 34.5C104.809 34.5 112 41.6906 112 50.5606C112 53.4859 111.218 56.2286 109.851 58.5909L111.197 65.8182L103.97 64.4726C101.607 65.8391 98.8647 66.6212 95.9394 66.6212Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13398_258136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white"
  })))));
});
export default SvgIconConversation;
export const raw = __webpack_public_path__ + "static/media/icon-conversation.f9ffd43af24e89be81bcc816cd3ac877.svg";